import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconPlatformAndroidSvg } from "./IconPlatformAndroidSvg.mjs";
const IconPlatformAndroid = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconPlatformAndroidSvg, ...svgProps }) });
export {
  IconPlatformAndroid
};
